import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  noWrap: {
    flexWrap: "nowrap !important"
  }
}));
const OSSMultiSelectAutocomplete = ({ matchKey, ...rest }) => {
  const classes = useStyles();

  return (
    <Autocomplete
      multiple
      autoComplete
      autoHighlight
      getOptionLabel={option => {
        // Technically speaking, an array is an Object so this was failing for arrays of options
        if (Array.isArray(option)) {
          return option.map(o => (o?.[matchKey] || '')).join(", ");
        }
        return typeof option === "object" ? option?.[matchKey] : option
      }}
      className={classes.noWrap}
      {...rest}
    />
  );
};

export default OSSMultiSelectAutocomplete;
